<template>
  <div class="row recursive-row" v-show="show" >
    <div class="col-sm-9 col-md-5 ellipsis-text align-self-center">
      <indented-span :level="level + 1" :hasHighlight="searchMatches">
        {{ pool | poolName }}
      </indented-span>
    </div>
    <div class="col-md-2 d-none d-md-block ellipsis-text align-self-center">
      {{ pool.count }} <span v-if="!isMember">/ {{ pool.aggregate_count }}</span> available
    </div>
    <div v-if="!isMember" class="col-md-3 d-none d-md-block ellipsis-text align-self-center">
      <span v-if="pool.contract_end">until {{ pool.contract_end | prettyDate }}</span>
    </div>
    <div v-if="!isMember" class="col-sm-2 text-right align-self-center">
      <button class="btn btn-sm" @click="selectLicense">Select</button>
    </div>
  </div>
</template>

<script>
import IndentedSpan from '../IndentedSpan.vue';
import config from '../../constants/config';
import { mapGetters } from 'vuex';

export default {
  name: 'LicenseRow',
  components: {
    IndentedSpan
  },
  props: {
    pool: Object,
    group: Object,
    level: Number,
    searchTerm: String,
    hideForParent: Boolean
  },
  data() {
    return {
      hideForSearch: false
    }
  },
  methods: {
    selectLicense() {
      this.$store.commit('licensePool/selectPool', {
        ...this.pool,
        group: this.group
      });
      this.$bvModal.show(config.LICENSE_MODAL_ID);
    }
  },
  computed: {
    ...mapGetters('user', ['isMember']),
    searchMatches() {
      return this.searchTerm != "" &&
        (this.pool.license_type.product.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        this.pool.license_type.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
    },
    show() {
      return !this.hideForParent && !this.hideForSearch;
    }
  },
  watch: {
    searchTerm(newTerm) {
      if (!newTerm) {
        this.hideForSearch = false;
      } else if (this.searchMatches) {
        this.$emit('searchFound', newTerm);
        this.hideForSearch = false;
      } else {
        this.hideForSearch = true;
      }
    }
  }
};
</script>
